module.exports = __webpack_public_path__ + "static/theme-editor-newsletter-popup-465ad6598ff8926a09ab826e067e0666.png";